import React from 'react';
import {Card, CardBody,} from 'reactstrap';

import {ButtonCancel} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteMsg,
    error,
    NO,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {galleryActivityservice} from "../../../jwt/_services/relations/galleryActivityService";
import {MediaGallery} from "../../../components/gallery/mediaGallery";
import {confirmAlert} from "react-confirm-alert";
import {MediaForm} from "../../clasificators/media/_form";
import {showLoader} from "../../../components/loader/loader";

class AvtivityGallery extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activity: this.props.parent,
            item: undefined,
            loading: false,
            listItems: [],
        };

        this.refreshList = this.refreshList.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.setDefault = this.setDefault.bind(this);
        this.setEdit = this.setEdit.bind(this);
        this.getGallery = this.getGallery.bind(this);
        this.setForm = this.setForm.bind(this);
        this.saveRelation = this.saveRelation.bind(this);
        this.updateRelation = this.updateRelation.bind(this);
        this.refGallery = React.createRef();
        this.refForm = React.createRef();
    }

    async componentDidMount() {
        await this.getGallery();
    }

    async getGallery() {
        this.setState({
            loading: true,
            listItems: []
        });
        let filteredItems = [];

        const data = {
            activity: {
                id: this.state?.activity?.id
            }
        };

        galleryActivityservice.search(data)
            .then(result => {
                if (result){
                    result.map((galleryItem) => {
                        const newItem = {
                            id: galleryItem.id,
                            media: {
                                id: galleryItem.media.id
                            },
                            activity: galleryItem.activity,
                            mediaDefault: galleryItem.mediaDefault,

                            url: galleryItem.media.url,
                            fileName: galleryItem.media.fileName,
                        };
                        filteredItems.push(newItem);

                    });

                    this.setState({listItems: filteredItems});
                    this.refGallery.current.setItems(filteredItems);
                    this.setState({loading: false});
                }
            })
            .catch(
                error => this.setState({loading: false, error: error.message})
            )
            .finally( _ =>
                this.setState({loading: false})
            );
    }

    async refreshList() {
        await this.getGallery();
    }

    setForm() {
        this.props.setForm();
    }

    async saveRelation(id, mediaDefault) {
        const dataRequest = {
            uid: '',
            media: { id: id },
            activity: { id: this.state.activity.id },
            mediaDefault: mediaDefault,
        };

        //Save
        return await galleryActivityservice.saveItem(dataRequest)
            .then(() => {
                this.refreshList();
                return true
            })
            .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            this.refreshList();
        });
    }

    updateRelation(id, mediaDefault) {
        const dataRequest = {
            id: id,
            uid: '',
            media: {
                id: id
            },
            activity: {
                id: this.state.activity.id
            },
            mediaDefault: mediaDefault,
        };

        //Save
        return galleryActivityservice.updateItem(id, dataRequest).then(() => {
            this.refreshList();
        }).catch(errorMessage => {
            showToastCustom(error, errorMessage);
        });
    }

    setDefault(galleryActivityId, mediaId, mediaDefault) {
        const dataRequest = {
            id: galleryActivityId,
            mediaDefault: mediaDefault,
            activity: {
                id: this.state.activity.id
            },
            media: {
                id: mediaId
            },
        };

        //Update
        return galleryActivityservice.setDefault(dataRequest)
            .then(_ => {
                this.getGallery().then(_ => {
                });
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
            });
    }

    async confirmDelete(id) {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            this.deleteItem(id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    }

    async deleteItem(id) {
        galleryActivityservice.deleteItem(id)
            .then(_ => {
                showToastCustom(warning, deleteMsg, true);
                this.getGallery();
            });
    }

    async setEdit(id) {

        galleryActivityservice.getItem(id)
            .then(item => {
                this.refForm.current.seFormEdit(item);
            });
    }

    render() {
        return (
            <Card className={'card-modal'}>
                {this.state.loading && showLoader()}
                <CardBody className={'card-body-modal'}>
                    <MediaForm
                        refreshList={this.refreshList}
                        setForm={this.setForm}
                        saveRelation={this.saveRelation}
                        updateRelation={this.updateRelation}
                        item={this.state.item}
                        ref={this.refForm}
                    />

                    <MediaGallery
                        items={this.state.listItems}
                        ref={this.refGallery}
                        refreshList={this.refreshList}
                        sendDelete={this.confirmDelete}
                        sendEdit={this.setEdit}
                        sendDefault={this.setDefault}
                    />

                </CardBody>

                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonCancel onClick={this.props.onClose}/>
                    </div>
                </CardBody>
            </Card>
        )
    }

}

export default AvtivityGallery;